import { FunctionComponent } from 'react';
import cx from 'clsx';

export type StepProps = {
  label: string;
  className?: string;
  progress: string;
};

export const Step: FunctionComponent<StepProps> = (props) => {
  return (
    <div className="relative flex flex-shrink-0 flex-col items-center gap-y-3">
      <div
        className={cx(
          'grid h-7 w-7 place-items-center rounded-full border border-black text-sm font-semibold',
          props.className,
        )}
      >
        {props.progress}
      </div>
      <div
        className={`absolute top-8 w-16 text-center text-sm sm:-bottom-8 sm:top-auto sm:mt-3.5 sm:w-32 md:text-base lg:text-base xl:text-base`}
      >
        <p
          className={`inline-block whitespace-normal break-words sm:w-full ${props.label.split(' ').length === 2 ? 'w-12' : 'w-full'}`}
        >
          {props.label}
        </p>
      </div>
    </div>
  );
};
